/* eslint-disable max-lines */
import { Card, Modal } from '@mantine/core';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from '../../components/elements/Button';
import ButtonLink from '../../components/elements/ButtonLink';
import SelectBox from '../../components/fields/SelectBox';
import Text from '../../components/fields/Text';
// import TextArea from '../../components/fields/TextArea';
import { toUpperCase } from '../../utils/format';
import { addCategoryToList, fetchCategory, fetchFaqById } from './actions';
import { dataPositions, validate } from './constants';
import FormCategory from './FormCategory';
import styles from './styles.scoped.css';

import { Editor } from '@tinymce/tinymce-react';
import TextArea from '../../components/fields/TextArea';
import { uploadImageFaq } from '../../utils/api';
import { TINYAPI } from '../../../env';

export function Component({
  change,
  handleSubmit,
  submitting,
  // item = {},
  // onCloseModal = () => {},
  type = null,
}) {
  const dispatch = useDispatch();

  const [position, setPosition] = useState('');
  const [category, setCategory] = useState('');
  const [answer, setAnswer] = useState('');
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [errorUpload, setErrorUpload] = useState('');
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [isCodeMode, setIsCodeMode] = useState(false);
  const [editorKey, setEditorKey] = useState(0);
  const editorRef = React.useRef(null);

  const { faqId = '' } = queryString.parse(location.search.replace('?', ''));

  const { dataFaqById, isLoadingFaqById, dataCategories } = useSelector(
    (s) => s.faq
  );

  const question = {
    placeholder: 'Tuliskan judul pertanyaan',
  };

  const description = {
    placeholder: 'Tulis jawaban dari pertanyaan diatas',
    label: 'Deskripsi',
  };

  const onChangeCategory = (e) => {
    if (e === 'tambah') {
      setOpenCategoryModal(true);
    } else {
      setCategory(e);
      setAfterSubmit(false);
      change('category', e);
    }
  };

  const onChangePosition = (e) => {
    setPosition(e);
    change('position', e);
  };

  useEffect(() => {
    dispatch(fetchCategory());
    if (type === 'edit') {
      dispatch(fetchFaqById(faqId));
    } else {
      change('category', '');
      change('position', '');
      change('answer', '');
      change('question', '');
    }
  }, []);

  const _handleEditorChange = (editorState) => {
    const val = editorState.target.getContent();
    setAnswer(val);
    change('answer', val);
  };

  const handleCodeModeChange = (e) => {
    const val = e.target.value;
    setAnswer(val);
    change('answer', val);
  };

  const toggleCodeMode = () => {
    if (!isCodeMode) {
      // Switching TO code mode: ambil konten terbaru dari TinyMCE
      if (editorRef.current) {
        const html = editorRef.current.getContent();
        setAnswer(html);
        change('answer', html);
      }
    } else {
      // Switching BACK to visual mode: increment key agar TinyMCE remount
      // dengan answer terbaru sebagai initialValue
      setEditorKey((prev) => prev + 1);
    }
    setIsCodeMode((prev) => !prev);
  };

  const fileToBase64 = (val) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(val);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const uploadImageCallBack = async (blobInfo, success) => {
    const file = blobInfo.blob();
    setErrorUpload('');
    if (file.size <= 2000000) {
      try {
        const base64 = await fileToBase64(file);
        const params = {
          image: base64,
        };
        const data = await uploadImageFaq(params);
        return success(data?.data?.link);
      } catch (error) {
        return error;
      }
    } else {
      setErrorUpload('Maksimal Ukuran file 2 MB');
    }
  };

  useEffect(() => {
    if (afterSubmit) {
      setOpenCategoryModal(false);
    }
  }, [afterSubmit]);

  useEffect(() => {
    if (!isLoadingFaqById && type === 'edit') {
      setPosition(dataFaqById?.position);
      setCategory(dataFaqById?.category);
      change('category', dataFaqById?.category);
      change('position', dataFaqById?.position);
      change('answer', dataFaqById?.answer);
      change('question', dataFaqById?.question);
      setAnswer(dataFaqById?.answer);
    } else {
      setPosition(dataPositions[1]?.value);
      setCategory('');
      change('category', '');
      change('position', dataPositions[1]?.value);
    }
  }, [isLoadingFaqById]);

  const setCategoryAfterAdd = (values) => {
    setCategory(toUpperCase(values.addCategory));
    change('category', toUpperCase(values.addCategory));
  };

  return (
    <div className={styles.form}>
      <Card className={styles.card}>
        <h4>{type === 'edit' ? 'Edit FAQ' : 'Buat FAQ'}</h4>
        <form onSubmit={handleSubmit}>
          <div className={styles['input-group']}>
            <label>Posisi FAQ </label>
            <Field
              component={SelectBox}
              data={dataPositions || []}
              defaultValue={position}
              name="position"
              onChangeSelect={(e) => onChangePosition(e)}
              searchable={false}
              valueForm={position}
            />
          </div>
          <div className={styles['input-group']}>
            <label>Kategori</label>
            <Field
              component={SelectBox}
              // data={[
              //   {
              //     value: "",
              //     label: "Pilih Kategori",
              //     group: " ",
              //     items: dataCategories,
              //   },
              //   { value: "tambah", label: "Tambah Kategori" },
              //   ,
              // ]}
              data={[
                {
                  group: ' ',
                  items: [{ value: 'tambah', label: 'Tambah Kategori' }],
                },
                {
                  group: ' ',
                  items: [
                    {
                      value: '',
                      label: 'Pilih Kategori',
                    },
                    ...dataCategories,
                  ],
                },
              ]}
              defaultValue={category}
              name="category"
              onChangeSelect={(e) => onChangeCategory(e)}
              searchable={false}
              valueForm={category}
            />
          </div>
          <div className={styles['input-group']}>
            <label>Judul Pertanyaan</label>
            <Field component={Text} inputProps={question} name="question" />
          </div>
          {/* <Field component={TextArea} inputProps={answer} name="answer" /> */}
          <div className={styles['input-group']}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <label style={{ margin: 0 }}>Deskripsi</label>
              <Button
                onClick={toggleCodeMode}
                size="small"
                style={isCodeMode ? 'danger' : 'blue'}
                type="button"
              >
                {isCodeMode ? 'Mode Visual' : 'Mode Code HTML'}
              </Button>
            </div>

            {isCodeMode ? (
              <div style={{ position: 'relative' }}>
                <div style={{
                  background: '#1e1e2e',
                  borderRadius: 8,
                  border: '1.5px solid #444',
                  overflow: 'hidden',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
                }}>
                  <div style={{
                    background: '#181825',
                    padding: '6px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    borderBottom: '1px solid #333',
                  }}>
                    <span style={{ width: 11, height: 11, borderRadius: '50%', background: '#ff5f57', display: 'inline-block' }} />
                    <span style={{ width: 11, height: 11, borderRadius: '50%', background: '#febc2e', display: 'inline-block' }} />
                    <span style={{ width: 11, height: 11, borderRadius: '50%', background: '#28c840', display: 'inline-block' }} />
                    <span style={{ color: '#888', fontSize: 12, marginLeft: 8, fontFamily: 'monospace' }}>HTML Code Editor</span>
                  </div>
                  <textarea
                    onChange={handleCodeModeChange}
                    placeholder="Tulis atau paste kode HTML di sini..."
                    spellCheck={false}
                    style={{
                      width: '100%',
                      minHeight: 420,
                      background: '#1e1e2e',
                      color: '#cdd6f4',
                      fontFamily: '"Fira Code", "Consolas", "Courier New", monospace',
                      fontSize: 14,
                      lineHeight: 1.7,
                      border: 'none',
                      outline: 'none',
                      resize: 'vertical',
                      padding: '16px 18px',
                      boxSizing: 'border-box',
                      display: 'block',
                      tabSize: 2,
                    }}
                    value={answer}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
                  <span style={{ color: '#888', fontSize: 12 }}>
                    {answer.length} karakter
                  </span>
                </div>
              </div>
            ) : (
              <Editor
                apiKey={TINYAPI}
                init={{
                  height: 600,
                  menubar: true,
                  config: {},
                  images_upload_credentials: true,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                  ],
                  toolbar: `link code image | formatselect | bold italic backcolor | \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | help`,
                  image_title: true,
                  automatic_uploads: true,
                  file_picker_types: 'image',
                  images_upload_handler: uploadImageCallBack,
                }}
                initialValue={answer}
                key={editorKey}
                onChange={_handleEditorChange}
                onInit={(evt, editor) => { editorRef.current = editor; }}
              >
                <Field
                  component={TextArea}
                  inputProps={description}
                  name="answer"
                />
              </Editor>
            )}
            <span style={{ color: '#EA2036' }}>{errorUpload}</span>
          </div>
          <div className={styles['form-action']}>
            <>
              <ButtonLink
                className={styles['action-btn-back']}
                outlined={true}
                to={'/faq'}
              >
                Kembali
              </ButtonLink>
              <Button disabled={submitting} type="submit">
                Simpan
              </Button>
            </>
          </div>
        </form>
      </Card>
      {type !== 'detail' && (
        <Modal centered opened={openCategoryModal} withCloseButton={false}>
          <FormCategory
            onBack={() => setOpenCategoryModal(false)}
            onSubmit={(values) =>
              dispatch(
                addCategoryToList(values),
                setOpenCategoryModal(false),
                setCategoryAfterAdd(values)
              )
            }
          />
        </Modal>
      )}
    </div>
  );
}

Component.propTypes = {
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  item: PropTypes.object,
  onCloseModal: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  type: PropTypes.string,
};

export default reduxForm({
  form: 'faq',
  initialValues: {
    question: '',
    answer: '',
    category: '',
    position: '',
  },
  validate,
})(Component);
